export default "__VITE_ASSET__a16384be__"